<template>
    <NoNetworksOverlay isShown></NoNetworksOverlay>
</template>

<script>
import externalPropsParser from 'services/utils/externalPropsParser';
import NoNetworksOverlay from 'pages/sdkNetworks/setup/NoNetworksOverlay.vue';
import eventBus from '@/mixins/eventBus';
import externalParsedProps from '@/mixins/externalParsedProps';

const parsedProps = ['isShown'];

export default {
    name: 'NoNetworksOverlayEx',
    mixins: [
        eventBus('no-networks-overlay-ex'),
        externalParsedProps(NoNetworksOverlay.props, parsedProps)
    ],
    props: externalPropsParser.setExternalProps(NoNetworksOverlay.props, parsedProps),
    components: { NoNetworksOverlay }
};
</script>
